import api from '@/lib/axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body = r.data as { data?: T };
  return body && typeof body === 'object' && 'data' in body ? (body.data as T) : (r.data as T);
}

export interface OrgDepartmentSubject {
  id: string;
  name: string;
}

export interface CreateOrgDepartmentData {
  schoolId: string;
  name: string;
  description?: string;
  subjectIds?: string[];
}

export interface UpdateOrgDepartmentData {
  schoolId: string;
  name?: string;
  description?: string;
  subjectIds?: string[];
}

export const OrgDepartmentsApi = {
  subjects: async (schoolId: string): Promise<OrgDepartmentSubject[]> =>
    unwrap(await api.get('/org/departments/subjects', { params: { schoolId } })),

  create: async (data: CreateOrgDepartmentData) => unwrap(await api.post('/org/departments', data)),

  update: async (id: string, data: UpdateOrgDepartmentData) =>
    unwrap(await api.patch(`/org/departments/${id}`, data)),

  remove: async (id: string, schoolId: string): Promise<void> =>
    unwrap(await api.delete(`/org/departments/${id}`, { params: { schoolId } })),

  generate: async (schoolId: string): Promise<{ created: number }> =>
    unwrap(await api.post('/org/departments/auto-generate', { schoolId })),
};
